module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/delete-b74d9c4aba264d6ac60c384bdfaa7e79.svg";